const DomHelper = require('../../../../client/clientjs/dom-helper.js')

module.exports = () => {
  const scrolls = DomHelper.queryAll('.is-horizontal-scroll')
  scrolls.forEach(element => {
    const container = DomHelper.query(element, '.horizontal-scroll-container')
    const leftArrow = DomHelper.query(element, '.horizontal-scroll-nav.horizontal-scroll-nav-left')
    const rightArrow = DomHelper.query(element, '.horizontal-scroll-nav.horizontal-scroll-nav-right')

    container.onscroll = () => {
      if (leftArrow) {
        if (container.scrollLeft <= 0) {
          DomHelper.addClass(leftArrow, 'hidden')
        } else {
          DomHelper.removeClass(leftArrow, 'hidden')
        }
      }
      if (rightArrow) {
        if (container.offsetWidth + container.scrollLeft >= container.scrollWidth) {
          DomHelper.addClass(rightArrow, 'hidden')
        } else {
          DomHelper.removeClass(rightArrow, 'hidden')
        }
      }
    }

    function scrollBy(by) {
      return setInterval(() => {
        container.scrollLeft += 3 * by
      }, 1)
    }

    if (leftArrow) {
      leftArrow.onmouseenter = () => {
        leftArrow.iid = scrollBy(-1)
      }
      leftArrow.onmouseleave = () => {
        if (leftArrow.iid) {
          clearInterval(leftArrow.iid)
        }
      }
    }
    if (rightArrow) {
      rightArrow.onmouseenter = () => {
        rightArrow.iid = scrollBy(1)
      }
      rightArrow.onmouseleave = () => {
        if (rightArrow.iid) {
          clearInterval(rightArrow.iid)
        }
      }
    }

    container.onscroll()
  })
}
